import React from "react";
import { ArrowUpRight } from "lucide-react";
import SectionHeading from "./SectionHeading";

const CoachingProjects = ({ t }) => (
  <section id="related-projects" data-testid="coaching-projects" className="relative py-16 md:py-24 scroll-mt-16">
    <div className="max-w-6xl mx-auto px-5 lg:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <SectionHeading index="04" title={t.projectsTitle} subtitle={t.projectsIntro} />
        <a
          href="/#projects"
          data-testid="coaching-projects-all-link"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1E90FF] hover:text-[#F3F6FA] transition-colors shrink-0"
        >
          {t.projectsCta} <ArrowUpRight size={16} />
        </a>
      </div>
      <div className="mt-10 grid sm:grid-cols-2 gap-4 md:gap-5">
        {t.relatedProjects.map((p) => (
          <article
            key={p.id}
            data-testid={`coaching-project-${p.id}`}
            className="bb-card rounded-2xl p-5 md:p-6"
          >
            <span className="font-mono text-[10px] tracking-[0.2em] text-[#1E90FF] border border-[#1E90FF]/30 rounded-full px-2.5 py-1">
              {p.badge}
            </span>
            <h3 className="mt-4 text-base md:text-lg font-bold text-[#F3F6FA]">{p.title}</h3>
            <p className="mt-2 text-sm text-[#C8CED8] leading-relaxed">{p.body}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default CoachingProjects;
